const PUBLIC_DOWNLOAD_ROUTE = /^\/(shared\/.+|report\/[^/]+)\/download\/?$/;

export function isPublicDownloadRoute(pathname: string): boolean {
  return PUBLIC_DOWNLOAD_ROUTE.test(pathname);
}
